import { Box } from '@mui/material';
import styled, { withTheme } from "styled-components";

const CountryMapStyles = styled(Box)`
    height: 400px;
`;

export default withTheme(CountryMapStyles)
